import SegmentUtils from 'utils/segment';
import { getCapturedReferrer, getCapturedPageProperties, } from 'utils/url-capture';
export default function trackSearchLanding(referrerAffiliate, destinationCategory) {
    // Get captured URL properties to preserve original URL/UTMs before routing modifications
    const { url: capturedUrl, path: capturedPath, search: capturedSearch, } = getCapturedPageProperties();
    const properties = {
        referrer_affiliate: referrerAffiliate,
        // Captured values already fall back to current location when not available
        user_facing_url: capturedUrl,
        url: capturedUrl,
        path: capturedPath,
        search: capturedSearch,
        referrer: getCapturedReferrer(),
        ...(destinationCategory && { destination_category: destinationCategory }),
    };
    SegmentUtils.page({
        name: 'Search Landing',
        properties,
    });
}
